import HeaderContent, { HeaderContentProps } from './HeaderContent';

export type { HeaderContentProps };
export default HeaderContent;
